import React, { useState, useEffect } from 'react';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Settings, DateTime } from 'luxon';

// Set Luxon to use the 'de' locale globally
Settings.defaultLocale = 'de';

type Props = {
  date: Date;
  setDate: (date: Date) => void;
}

const DateTimePickerComponent: React.FC<Props> = ({ date, setDate }) => {
  // Parse the date string from backend format to Luxon DateTime
  const parseDateString = (dateStr: string | Date) => {
    if (dateStr instanceof Date) {
      return DateTime.fromJSDate(dateStr);
    }
    return DateTime.fromFormat(dateStr, 'yyyy-MM-dd');
  };

  const [selectedDate, setSelectedDate] = useState<DateTime | null>(parseDateString(date));

  useEffect(() => {
    setSelectedDate(parseDateString(date));
  }, [date]);

  const handleDateChange = (newValue: DateTime | null) => {
    setSelectedDate(newValue);
    if (newValue) {
      // Format back to backend format yyyy-MM-dd
      const formattedDate = newValue.toFormat('yyyy-MM-dd');

      // Create a Date object that preserves the local date without timezone conversion
      const year = newValue.year;
      const month = newValue.month - 1; // JavaScript months are 0-indexed
      const day = newValue.day;
      const localDate = new Date(year, month, day);
      
      setDate(localDate);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale='de'>
      <DateTimePicker
        className='mui-date-time-picker'
        value={selectedDate}
        onChange={handleDateChange}
        views={['year', 'month', 'day']} // Only show date picker, no time
      />
    </LocalizationProvider>
  );
};

export default DateTimePickerComponent;